export const animeCategories = [
  { name: "热血", icon: "ri-fire-line" },
  { name: "奇幻", icon: "ri-magic-line" },
  { name: "恋爱", icon: "ri-heart-3-line" },
  { name: "悬疑", icon: "ri-search-eye-line" },
  { name: "搞笑", icon: "ri-emotion-laugh-line" },
  { name: "运动", icon: "ri-basketball-line" },
  { name: "科幻", icon: "ri-rocket-2-line" },
  { name: "治愈", icon: "ri-plant-line" },
  { name: "古风", icon: "ri-moon-clear-line" },
  { name: "音乐", icon: "ri-music-2-line" },
  { name: "战争", icon: "ri-shield-star-line" },
  { name: "日常", icon: "ri-sun-line" },
];

export const regions = ["全部", "日本", "中国", "欧美"];

export const years = ["全部", "2024", "2023", "2022", "2021", "2020", "2019", "2018"];

export const statuses = ["全部", "连载中", "已完结"];

export const sortOptions = ["最近更新", "热度最高", "评分最高", "上映年份"];

export const animes = [
  {
    id: "frieren",
    title: "葬送的芙莉莲",
    subtitle: "送别勇者之后，一段关于时间的旅程",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20calm%20silver%20haired%20elf%20mage%20girl%20in%20a%20white%20traveling%20cloak%20standing%20in%20a%20sunlit%20flower%20meadow%2C%20soft%20pastel%20colors%2C%20clean%20simple%20background%2C%20cinematic%20light%2C%20high%20detail&width=600&height=800&seq=sakura-anime-frieren-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20key%20visual%20of%20a%20silver%20haired%20elf%20mage%20traveling%20with%20companions%20across%20a%20vast%20misty%20grassland%20at%20golden%20hour%2C%20soft%20pastel%20pink%20sky%2C%20gentle%20glow%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-frieren-banner&orientation=landscape",
    year: 2023,
    region: "日本",
    genres: ["奇幻", "治愈"],
    status: "已完结",
    episodes: 28,
    currentEpisode: 28,
    rating: 9.6,
    views: "2.8亿",
    updateText: "全28集",
    studio: "MADHOUSE",
    director: "斋藤圭一郎",
    releaseDate: "2023年9月29日",
    intro:
      "勇者辛美尔一行人讨伐魔王后凯旋，队伍中的精灵魔法使芙莉莲拥有近乎无限的寿命。五十年后，勇者老去离世，芙莉莲才第一次为「不了解人类」而落泪。她带着新的同伴重新踏上旅途，去寻找那些被时间掩埋的答案。",
    tags: ["公路旅行", "精灵", "魔法", "催泪", "高口碑"],
    featured: true,
  },
  {
    id: "jujutsu-kaisen-s2",
    title: "咒术回战 第二季",
    subtitle: "涩谷事变，最强的崩坏之夜",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20white%20haired%20young%20sorcerer%20with%20glowing%20violet%20eyes%20and%20dark%20uniform%2C%20dramatic%20neon%20night%20city%20backdrop%2C%20sharp%20contrast%2C%20clean%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=600&height=800&seq=sakura-anime-jujutsu-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Dramatic%20anime%20key%20visual%20of%20two%20sorcerers%20facing%20a%20glowing%20curse%20energy%20explosion%20in%20a%20rainy%20night%20city%20crossing%2C%20deep%20magenta%20and%20violet%20light%2C%20painterly%20anime%20style%2C%20wide%20cinematic%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-jujutsu-banner&orientation=landscape",
    year: 2023,
    region: "日本",
    genres: ["热血", "奇幻"],
    status: "已完结",
    episodes: 23,
    currentEpisode: 23,
    rating: 9.2,
    views: "3.6亿",
    updateText: "全23集",
    studio: "MAPPA",
    director: "御所园翔太",
    releaseDate: "2023年7月6日",
    intro:
      "最强的咒术师五条悟被封印，涩谷陷入前所未有的混乱。虎杖悠仁与同伴们在这场被称为「涩谷事变」的灾难中，直面特级咒灵与咒术师的背叛，也第一次触碰到绝望的形状。",
    tags: ["咒术", "涩谷事变", "战斗", "超人气"],
    featured: true,
  },
  {
    id: "oshi-no-ko",
    title: "我推的孩子",
    subtitle: "谎言，是成为偶像的第一步",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20bright%20idol%20girl%20with%20long%20star%20shaped%20hair%20accessories%20singing%20under%20stage%20lights%2C%20sparkling%20magenta%20and%20pink%20glow%2C%20clean%20background%2C%20cinematic%20lighting%2C%20high%20detail&width=600&height=800&seq=sakura-anime-oshinoko-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20shining%20idol%20stage%20with%20pink%20spotlights%20and%20glowing%20confetti%2C%20silhouettes%20of%20fans%20holding%20light%20sticks%2C%20dreamy%20pastel%20pink%20and%20gold%20tones%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-oshinoko-banner&orientation=landscape",
    year: 2023,
    region: "日本",
    genres: ["悬疑", "恋爱"],
    status: "连载中",
    episodes: 13,
    currentEpisode: 11,
    rating: 9.0,
    views: "2.1亿",
    updateText: "更新至第11集",
    studio: "动画工房",
    director: "平牧大辅",
    releaseDate: "2023年4月12日",
    intro:
      "在小镇做妇产科医生的雨宫吾郎，是偶像星野爱的狂热粉丝。命运让他以「爱之子」的身份重获新生，而一场突如其来的悲剧，让这对兄妹踏入了光鲜又残酷的演艺圈。",
    tags: ["偶像", "转生", "复仇", "演艺圈"],
    featured: true,
  },
  {
    id: "dungeon-meshi",
    title: "迷宫饭",
    subtitle: "打倒魔物，然后把它吃掉",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20cheerful%20adventurer%20party%20cooking%20monster%20meat%20over%20a%20campfire%20inside%20a%20stone%20dungeon%2C%20warm%20golden%20light%2C%20playful%20mood%2C%20clean%20composition%2C%20high%20detail&width=600&height=800&seq=sakura-anime-dungeon-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cozy%20anime%20key%20visual%20of%20adventurers%20sharing%20a%20meal%20inside%20a%20magical%20dungeon%20hall%20lit%20by%20lanterns%2C%20warm%20amber%20and%20rose%20tones%2C%20steaming%20dishes%20on%20a%20wooden%20table%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-dungeon-banner&orientation=landscape",
    year: 2024,
    region: "日本",
    genres: ["奇幻", "搞笑"],
    status: "已完结",
    episodes: 24,
    currentEpisode: 24,
    rating: 8.9,
    views: "1.7亿",
    updateText: "全24集",
    studio: "TRIGGER",
    director: "宫岛善博",
    releaseDate: "2024年1月4日",
    intro:
      "为了救回被红龙吞下的妹妹，莱欧斯一行人决定就地取材——把迷宫里的魔物做成料理。一场关于食欲、友情与生存的荒诞美食冒险，就此开锅。",
    tags: ["美食", "迷宫", "冒险", "轻松"],
    featured: true,
  },
  {
    id: "bocchi-the-rock",
    title: "孤独摇滚！",
    subtitle: "社恐少女的乐队练习日记",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20shy%20pink%20haired%20girl%20hugging%20an%20electric%20guitar%20in%20a%20small%20bedroom%20with%20band%20posters%2C%20soft%20pastel%20pink%20light%2C%20clean%20simple%20background%2C%20cinematic%20light%2C%20high%20detail&width=600&height=800&seq=sakura-anime-bocchi-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Bright%20anime%20key%20visual%20of%20a%20girl%20band%20performing%20on%20a%20small%20stage%20with%20pink%20and%20violet%20lights%2C%20flying%20sakura%20petals%2C%20energetic%20motion%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-bocchi-banner&orientation=landscape",
    year: 2022,
    region: "日本",
    genres: ["音乐", "日常"],
    status: "已完结",
    episodes: 12,
    currentEpisode: 12,
    rating: 9.4,
    views: "1.3亿",
    updateText: "全12集",
    studio: "CloverWorks",
    director: "斋藤圭一郎",
    releaseDate: "2022年10月8日",
    intro:
      "极度社恐的后藤一里，从初中开始独自练琴，却从未交到朋友。某天她被乐队成员伊地知虹夏拉进「结束乐队」，在舞台与社交恐惧之间反复横跳的青春故事就此开始。",
    tags: ["乐队", "社恐", "青春", "名场面"],
    featured: false,
  },
  {
    id: "demon-slayer-training",
    title: "鬼灭之刃 柱训练篇",
    subtitle: "为了与无惨决战的那一天",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20young%20swordsman%20in%20a%20green%20checkered%20haori%20drawing%20a%20glowing%20blade%20in%20a%20misty%20bamboo%20forest%2C%20teal%20and%20pink%20light%2C%20cinematic%20composition%2C%20high%20detail&width=600&height=800&seq=sakura-anime-demon-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20anime%20key%20visual%20of%20demon%20slayers%20training%20under%20a%20waterfall%20at%20dawn%20with%20sakura%20blossoms%20drifting%2C%20soft%20rose%20and%20teal%20gradient%20sky%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-demon-banner&orientation=landscape",
    year: 2024,
    region: "日本",
    genres: ["热血", "奇幻"],
    status: "已完结",
    episodes: 8,
    currentEpisode: 8,
    rating: 8.8,
    views: "2.4亿",
    updateText: "全8集",
    studio: "ufotable",
    director: "外崎春雄",
    releaseDate: "2024年5月12日",
    intro:
      "柱们为了让鬼杀队全员战力提升，开启了严苛的联合训练。炭治郎与伙伴们逐一接受各位柱的指导，在与强大前辈的碰撞中，为即将到来的最终决战蓄力。",
    tags: ["鬼杀队", "柱", "修行", "作画"],
    featured: false,
  },
  {
    id: "chainsaw-man",
    title: "电锯人",
    subtitle: "少年与恶魔的契约",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20rough%20young%20devil%20hunter%20holding%20a%20chainsaw%20in%20a%20rainy%20neon%20alley%2C%20gritty%20texture%2C%20red%20and%20pink%20rim%20light%2C%20cinematic%20composition%2C%20high%20detail&width=600&height=800&seq=sakura-anime-chainsaw-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Gritty%20anime%20key%20visual%20of%20a%20devil%20hunter%20standing%20in%20a%20rain%20soaked%20city%20street%20surrounded%20by%20glowing%20red%20chain%20sparks%2C%20dramatic%20backlight%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-chainsaw-banner&orientation=landscape",
    year: 2022,
    region: "日本",
    genres: ["热血", "悬疑"],
    status: "已完结",
    episodes: 12,
    currentEpisode: 12,
    rating: 9.1,
    views: "1.9亿",
    updateText: "全12集",
    studio: "MAPPA",
    director: "中山龙",
    releaseDate: "2022年10月11日",
    intro:
      "背负父亲债务的少年电次，与链锯恶魔波奇塔相依为命。一次背叛让他与波奇塔融为一体，成为「电锯人」，从此被卷入公安恶魔猎人的血色日常。",
    tags: ["恶魔", "黑暗", "战斗", "剧场版"],
    featured: false,
  },
  {
    id: "haikyuu-s4",
    title: "排球少年!! 第四季",
    subtitle: "飞吧，向着全国大赛",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20short%20orange%20haired%20volleyball%20player%20jumping%20for%20a%20spike%20in%20a%20bright%20gymnasium%2C%20dynamic%20motion%2C%20warm%20sunlight%2C%20clean%20composition%2C%20high%20detail&width=600&height=800&seq=sakura-anime-haikyuu-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Energetic%20anime%20key%20visual%20of%20a%20high%20school%20volleyball%20team%20celebrating%20on%20court%20with%20confetti%20and%20warm%20spotlights%2C%20orange%20and%20rose%20tones%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-haikyuu-banner&orientation=landscape",
    year: 2024,
    region: "日本",
    genres: ["运动", "热血"],
    status: "连载中",
    episodes: 25,
    currentEpisode: 18,
    rating: 9.3,
    views: "1.5亿",
    updateText: "更新至第18集",
    studio: "Production I.G",
    director: "佐藤雅子",
    releaseDate: "2024年1月6日",
    intro:
      "乌野高中排球部终于站上全国大赛的舞台。日向翔阳与影山飞雄这对怪人快攻组合，将面对来自全国的强敌，用一次次跳跃证明「小巨人」的梦想并不渺小。",
    tags: ["排球", "青春", "团队", "热血"],
    featured: false,
  },
  {
    id: "apothecary-diaries",
    title: "药屋少女的呢喃",
    subtitle: "后宫深处，一剂解谜的良药",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20clever%20girl%20apothecary%20in%20a%20pale%20green%20hanfu%20holding%20herbs%20in%20an%20ornate%20palace%20corridor%2C%20soft%20rose%20and%20jade%20light%2C%20clean%20composition%2C%20high%20detail&width=600&height=800&seq=sakura-anime-kusuriya-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Elegant%20anime%20key%20visual%20of%20a%20moonlit%20imperial%20palace%20courtyard%20with%20blooming%20plum%20branches%20and%20lanterns%2C%20soft%20pink%20and%20gold%20light%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-kusuriya-banner&orientation=landscape",
    year: 2023,
    region: "日本",
    genres: ["古风", "悬疑"],
    status: "已完结",
    episodes: 24,
    currentEpisode: 24,
    rating: 8.7,
    views: "9800万",
    updateText: "全24集",
    studio: "TOHO animation STUDIO",
    director: "长沼范裕",
    releaseDate: "2023年10月22日",
    intro:
      "精通药理的少女猫猫被卖入后宫做杂役，本以为可以安静研究草药，却因一句无心的推测卷入皇嗣之谜。宫廷的每一缕香气里，都可能藏着毒。",
    tags: ["宫廷", "推理", "药理", "猫猫"],
    featured: false,
  },
  {
    id: "mushoku-s2",
    title: "无职转生 第二季",
    subtitle: "带着前世的悔恨重新活一次",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20young%20mage%20boy%20with%20grey%20hair%20casting%20a%20gentle%20light%20spell%20on%20a%20wheat%20field%20road%2C%20warm%20sunset%2C%20clean%20composition%2C%20high%20detail&width=600&height=800&seq=sakura-anime-mushoku-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Warm%20anime%20key%20visual%20of%20a%20traveling%20mage%20party%20on%20a%20country%20road%20at%20sunset%20with%20distant%20mountains%20and%20pink%20clouds%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-mushoku-banner&orientation=landscape",
    year: 2023,
    region: "日本",
    genres: ["奇幻"],
    status: "连载中",
    episodes: 12,
    currentEpisode: 9,
    rating: 8.6,
    views: "1.1亿",
    updateText: "更新至第9集",
    studio: "Studio Bind",
    director: "平野宏树",
    releaseDate: "2023年7月2日",
    intro:
      "转生到异世界的鲁迪乌斯，带着前世的自卑与悔恨，一点点学会与人相处。母亲的失踪、家族的分离、成长的代价，都逼着他从男孩变成大人。",
    tags: ["异世界", "成长", "魔法", "冒险"],
    featured: false,
  },
  {
    id: "blue-lock",
    title: "蓝色监狱",
    subtitle: "为了成为世界第一前锋",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20determined%20teenage%20football%20striker%20with%20blue%20glowing%20eyes%20in%20a%20stadium%20tunnel%2C%20cool%20blue%20rim%20light%2C%20clean%20composition%2C%20high%20detail&width=600&height=800&seq=sakura-anime-bluelock-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Intense%20anime%20key%20visual%20of%20a%20football%20striker%20striking%20the%20ball%20under%20stadium%20floodlights%20with%20blue%20energy%20trails%2C%20dramatic%20motion%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-bluelock-banner&orientation=landscape",
    year: 2023,
    region: "日本",
    genres: ["运动", "热血"],
    status: "连载中",
    episodes: 24,
    currentEpisode: 20,
    rating: 8.5,
    views: "8600万",
    updateText: "更新至第20集",
    studio: "8bit",
    director: "渡边彻明",
    releaseDate: "2023年4月8日",
    intro:
      "日本足球联盟为了打造世界第一前锋，启动了名为「蓝色监狱」的极限集训。三百名高中前锋被关进设施，只有最自我、最贪婪的人才能活到最后。",
    tags: ["足球", "竞技", "群像", "自我"],
    featured: false,
  },
  {
    id: "link-click",
    title: "时光代理人",
    subtitle: "进入照片，改变过去",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20two%20young%20men%20standing%20in%20a%20rainy%20neon%20city%20under%20a%20street%20lamp%20with%20glowing%20photo%20frames%20floating%20around%2C%20moody%20pink%20and%20cyan%20light%2C%20high%20detail&width=600&height=800&seq=sakura-anime-linkclick-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Moody%20anime%20key%20visual%20of%20a%20rainy%20modern%20city%20at%20night%20with%20glowing%20photo%20frames%20and%20light%20trails%2C%20pink%20and%20teal%20reflections%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-linkclick-banner&orientation=landscape",
    year: 2021,
    region: "中国",
    genres: ["悬疑", "科幻"],
    status: "已完结",
    episodes: 11,
    currentEpisode: 11,
    rating: 9.0,
    views: "1.2亿",
    updateText: "全11集",
    studio: "澜映画",
    director: "李豪凌",
    releaseDate: "2021年4月30日",
    intro:
      "程小时能进入照片，回到照片拍下的那一刻；陆光能看到照片之后发生的事。两人合作接受委托，替人完成遗憾，却在一次次「不要改变过去」的规则里，撞见无法回头的真相。",
    tags: ["国产", "穿越", "悬疑", "治愈"],
    featured: false,
  },
  {
    id: "mdzs",
    title: "魔道祖师",
    subtitle: "是非在己，毁誉由人",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20an%20elegant%20young%20man%20in%20black%20and%20red%20robes%20playing%20a%20flute%20on%20a%20misty%20cliff%20at%20dusk%2C%20ink%20wash%20style%2C%20soft%20pink%20clouds%2C%20high%20detail&width=600&height=800&seq=sakura-anime-mdzs-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Ink%20wash%20anime%20key%20visual%20of%20floating%20mountains%20and%20mist%20with%20glowing%20talismans%20and%20sakura%20petals%2C%20soft%20rose%20and%20ink%20blue%20tones%2C%20wide%20cinematic%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-mdzs-banner&orientation=landscape",
    year: 2018,
    region: "中国",
    genres: ["古风", "奇幻"],
    status: "已完结",
    episodes: 23,
    currentEpisode: 23,
    rating: 8.8,
    views: "3.1亿",
    updateText: "全23集",
    studio: "视美影业",
    director: "熊可",
    releaseDate: "2018年7月9日",
    intro:
      "十三年后，魏无羡以一句「我回来了」重返人间。前尘旧事、仙门恩怨、故人重逢，在琴声与鬼笛之间缓缓展开。",
    tags: ["国漫", "仙侠", "群像", "名作"],
    featured: false,
  },
  {
    id: "ling-cage",
    title: "灵笼",
    subtitle: "在末世里，重新定义人",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%203d%20anime%20poster%20of%20a%20mech%20pilot%20in%20a%20worn%20armor%20suit%20standing%20on%20a%20ruined%20rooftop%20with%20floating%20dust%20and%20pink%20haze%2C%20cinematic%20sci%20fi%20lighting%2C%20high%20detail&width=600&height=800&seq=sakura-anime-linglong-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20sci%20fi%20anime%20key%20visual%20of%20a%20giant%20mech%20walking%20through%20a%20ruined%20city%20under%20a%20pink%20dust%20sky%2C%20dramatic%20scale%2C%20painterly%203d%20render%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-linglong-banner&orientation=landscape",
    year: 2019,
    region: "中国",
    genres: ["科幻", "战争"],
    status: "连载中",
    episodes: 16,
    currentEpisode: 12,
    rating: 8.4,
    views: "7600万",
    updateText: "更新至第12集",
    studio: "艺画开天",
    director: "董相博",
    releaseDate: "2019年7月5日",
    intro:
      "地表被灾变吞噬后，人类躲进名为「灯塔」的空中堡垒，以严苛的等级制度延续文明。猎荒者马克在一次任务中发现了灯塔之外的另一种可能。",
    tags: ["国漫", "末世", "机甲", "3D"],
    featured: false,
  },
  {
    id: "tgcf",
    title: "天官赐福",
    subtitle: "身在无间，心在桃源",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20graceful%20young%20man%20in%20white%20robes%20with%20a%20bamboo%20hat%20standing%20among%20floating%20lanterns%2C%20warm%20gold%20and%20pink%20light%2C%20elegant%20composition%2C%20high%20detail&width=600&height=800&seq=sakura-anime-tgcf-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Dreamy%20anime%20key%20visual%20of%20hundreds%20of%20glowing%20sky%20lanterns%20floating%20over%20an%20ancient%20chinese%20city%20at%20night%2C%20soft%20pink%20and%20gold%20tones%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-tgcf-banner&orientation=landscape",
    year: 2020,
    region: "中国",
    genres: ["古风", "奇幻"],
    status: "连载中",
    episodes: 11,
    currentEpisode: 8,
    rating: 8.7,
    views: "1.8亿",
    updateText: "更新至第8集",
    studio: "彩条屋",
    director: "李豪凌",
    releaseDate: "2020年10月31日",
    intro:
      "八百年前被贬下凡的仙乐国太子谢怜，第三次飞升后成了人人避之不及的「破烂仙人」。在人间收妖的路上，他遇见了那位一直等着他的鬼王。",
    tags: ["国漫", "仙侠", "缘分", "唯美"],
    featured: false,
  },
  {
    id: "cyberpunk-edgerunners",
    title: "赛博朋克：边缘行者",
    subtitle: "在夜之城，没有人能全身而退",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20young%20cyberpunk%20runner%20with%20neon%20implants%20in%20a%20rainy%20neon%20city%20alley%2C%20electric%20magenta%20and%20cyan%20light%2C%20cinematic%20composition%2C%20high%20detail&width=600&height=800&seq=sakura-anime-cyberpunk-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Neon%20drenched%20anime%20key%20visual%20of%20a%20futuristic%20city%20skyline%20with%20holograms%20and%20flying%20cars%2C%20magenta%20and%20pink%20glow%2C%20painterly%20anime%20style%2C%20wide%20cinematic%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-cyberpunk-banner&orientation=landscape",
    year: 2022,
    region: "日本",
    genres: ["科幻", "战争"],
    status: "已完结",
    episodes: 10,
    currentEpisode: 10,
    rating: 9.2,
    views: "1.4亿",
    updateText: "全10集",
    studio: "TRIGGER",
    director: "今石洋之",
    releaseDate: "2022年9月13日",
    intro:
      "在科技泛滥的夜之城，街头少年大卫失去了母亲，也失去了一切退路。他装上军用义体，成为游走于法律之外的边缘行者，用燃烧生命的方式向前奔跑。",
    tags: ["赛博朋克", "悲剧", "义体", "神作"],
    featured: false,
  },
  {
    id: "eighty-six",
    title: "86-不存在的战区-",
    subtitle: "无人知晓的战场上，他们也曾活过",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20young%20female%20commander%20with%20silver%20hair%20in%20a%20white%20uniform%20looking%20at%20distant%20battlefield%20smoke%2C%20muted%20rose%20and%20grey%20tones%2C%20cinematic%20lighting%2C%20high%20detail&width=600&height=800&seq=sakura-anime-86-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Moody%20anime%20key%20visual%20of%20a%20battlefield%20at%20dawn%20with%20destroyed%20mechs%20and%20pink%20mist%2C%20a%20lone%20soldier%20silhouette%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-86-banner&orientation=landscape",
    year: 2021,
    region: "日本",
    genres: ["战争", "科幻"],
    status: "已完结",
    episodes: 23,
    currentEpisode: 23,
    rating: 8.9,
    views: "7200万",
    updateText: "全23集",
    studio: "A-1 Pictures",
    director: "石井俊匡",
    releaseDate: "2021年4月10日",
    intro:
      "共和国宣称以无人机进行零伤亡战争，实际上驾驶机甲的是被剥夺姓名的「86」。少年辛与指挥官蕾娜隔着通讯线路相遇，试图在谎言中守住彼此的声音。",
    tags: ["战争", "机甲", "催泪", "群像"],
    featured: false,
  },
  {
    id: "summertime-render",
    title: "夏日重现",
    subtitle: "这个夏天，我要救回所有人",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20teenage%20boy%20standing%20on%20a%20seaside%20pier%20at%20sunset%20with%20a%20girl%20silhouette%20and%20eerie%20shadows%2C%20warm%20orange%20and%20pink%20tones%2C%20high%20detail&width=600&height=800&seq=sakura-anime-summer-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Summer%20anime%20key%20visual%20of%20a%20small%20island%20town%20harbor%20at%20sunset%20with%20festival%20lanterns%20and%20long%20shadows%2C%20warm%20pink%20and%20gold%20light%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-summer-banner&orientation=landscape",
    year: 2022,
    region: "日本",
    genres: ["悬疑", "科幻"],
    status: "已完结",
    episodes: 25,
    currentEpisode: 25,
    rating: 8.9,
    views: "9300万",
    updateText: "全25集",
    studio: "OLM",
    director: "渡边步",
    releaseDate: "2022年4月14日",
    intro:
      "为了参加青梅竹马的葬礼，网代慎平回到阔别两年的日都岛。岛上流传着「影子」的传说，而每一次死亡，都会让他回到同一个夏天。",
    tags: ["轮回", "海岛", "悬疑", "高能"],
    featured: false,
  },
  {
    id: "yuru-camp-s3",
    title: "摇曳露营△ 第三季",
    subtitle: "一个人的露营，也很热闹",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20two%20girls%20sitting%20by%20a%20tent%20with%20a%20campfire%20and%20lake%20view%20at%20dusk%2C%20soft%20pastel%20pink%20sky%2C%20cozy%20mood%2C%20clean%20composition%2C%20high%20detail&width=600&height=800&seq=sakura-anime-yurucamp-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Peaceful%20anime%20key%20visual%20of%20a%20lakeside%20campsite%20at%20twilight%20with%20tents%2C%20warm%20lanterns%20and%20distant%20mountains%2C%20soft%20pink%20and%20lavender%20sky%2C%20painterly%20anime%20style%2C%20wide%20composition%2C%20high%20detail&width=1600&height=800&seq=sakura-anime-yurucamp-banner&orientation=landscape",
    year: 2024,
    region: "日本",
    genres: ["治愈", "日常"],
    status: "已完结",
    episodes: 12,
    currentEpisode: 12,
    rating: 8.6,
    views: "4600万",
    updateText: "全12集",
    studio: "8bit",
    director: "登坂晋",
    releaseDate: "2024年4月4日",
    intro:
      "凛、抚子与野外活动社的伙伴们，继续在山梨的四季里搭帐篷、煮热汤、看日出。没有拯救世界的剧情，只有被风吹动的草地和一杯刚泡好的咖啡。",
    tags: ["露营", "治愈", "日常", "风景"],
    featured: false,
  },
];

export const heroSlides = [
  {
    id: "hero-frieren",
    animeId: "frieren",
    title: "葬送的芙莉莲",
    subtitle: "送别勇者之后，一段关于时间的旅程",
    description:
      "二十八集完结篇现已全集上线。跟随精灵魔法使芙莉莲，重新走一遍那条通往回忆的路。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20key%20visual%20of%20a%20silver%20haired%20elf%20mage%20walking%20through%20an%20endless%20flower%20field%20under%20a%20soft%20pink%20sunset%20sky%2C%20glowing%20particles%2C%20painterly%20anime%20style%2C%20wide%20panoramic%20composition%2C%20high%20detail&width=1600&height=760&seq=sakura-hero-frieren-main&orientation=landscape",
    tags: ["奇幻", "治愈", "高口碑"],
    rating: 9.6,
  },
  {
    id: "hero-jujutsu",
    animeId: "jujutsu-kaisen-s2",
    title: "咒术回战 第二季",
    subtitle: "涩谷事变，最强的崩坏之夜",
    description:
      "五条悟被封印之后，涩谷的夜色彻底改变。全二十三集高能战斗，一次看个够。",
    image:
      "https://readdy.ai/api/search-image?query=Dramatic%20anime%20key%20visual%20of%20a%20sorcerer%20unleashing%20violet%20curse%20energy%20in%20a%20flooded%20neon%20city%20street%20at%20night%2C%20magenta%20and%20teal%20reflections%2C%20painterly%20anime%20style%2C%20wide%20panoramic%20composition%2C%20high%20detail&width=1600&height=760&seq=sakura-hero-jujutsu-main&orientation=landscape",
    tags: ["热血", "奇幻", "战斗"],
    rating: 9.2,
  },
  {
    id: "hero-oshinoko",
    animeId: "oshi-no-ko",
    title: "我推的孩子",
    subtitle: "谎言，是成为偶像的第一步",
    description:
      "舞台灯光亮起的瞬间，所有谎言都有了意义。新集数每周更新中。",
    image:
      "https://readdy.ai/api/search-image?query=Glowing%20anime%20key%20visual%20of%20an%20idol%20stage%20with%20pink%20spotlights%2C%20floating%20confetti%20and%20a%20star%20shaped%20halo%2C%20dreamy%20pastel%20rose%20tones%2C%20painterly%20anime%20style%2C%20wide%20panoramic%20composition%2C%20high%20detail&width=1600&height=760&seq=sakura-hero-oshinoko-main&orientation=landscape",
    tags: ["悬疑", "偶像", "连载中"],
    rating: 9.0,
  },
  {
    id: "hero-dungeon",
    animeId: "dungeon-meshi",
    title: "迷宫饭",
    subtitle: "打倒魔物，然后把它吃掉",
    description:
      "把迷宫变成厨房，把魔物做成晚餐。一部会让你饿肚子的奇幻冒险。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20anime%20key%20visual%20of%20a%20dungeon%20feast%20with%20steaming%20dishes%2C%20lanterns%20and%20adventurers%20laughing%20around%20a%20long%20wooden%20table%2C%20amber%20and%20rose%20tones%2C%20painterly%20anime%20style%2C%20wide%20panoramic%20composition%2C%20high%20detail&width=1600&height=760&seq=sakura-hero-dungeon-main&orientation=landscape",
    tags: ["奇幻", "搞笑", "美食"],
    rating: 8.9,
  },
];